import { render, staticRenderFns } from "./CreateTaskRules.vue?vue&type=template&id=50da5358&scoped=true&"
import script from "./CreateTaskRules.vue?vue&type=script&lang=js&"
export * from "./CreateTaskRules.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskRules.vue?vue&type=style&index=0&id=50da5358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da5358",
  null
  
)

export default component.exports